<template>
<div style="background: #f7f7f7;">
    <headerNav title="订单追踪" />

    <van-cell-group>
        <van-cell title="订单编号" :value="tid" />
    </van-cell-group>
    <van-cell-group>
        <van-cell title="快递方式" :value="logsinfo.companyName" />
        <van-cell title="快递单号" :value="logsinfo.logisticCode" />
    </van-cell-group>
    <van-steps direction="vertical" :active="0" active-color="#f60" style="margin-top: 15px;">
        <van-step v-for="(item,index) in logsinfo.traces" :key="index">
            <h3>{{item.acceptStation}}</h3>
            <p>{{item.acceptTime}}</p>
        </van-step>
    </van-steps>
    <!-- <van-tabs >
        <van-tab title="快递">
           
        </van-tab>
        <van-tab title="包裹2">内容 3</van-tab>
    </van-tabs> -->

</div>
</template>

<script>
export default {
    data() {
        return {
            QueryLogisticsinfoInputDto: {
                tid: '',
                logisticsNo: ''
            },
            logsinfo: {},
            tid: '',
            logisticNo: ''
        }
    },
    created() {
        var option = this.$route.query;
        this.tid = option.tid;
        this.logisticNo = option.logisticNo;
        if (this.tid) {
            this.QueryLogisticsinfoInputDto.tid = this.tid;
            this.QueryLogisticsinfoInputDto.logisticsNo = this.logisticNo;
            this.getloginfo();
        }
    },
    methods: {
        getloginfo() {
            this.ajax.post('/api/services/app/PhoneTrade/QueryTidLogInfo', this.QueryLogisticsinfoInputDto).then(x => {
                this.logsinfo = x.result;
            })
        }
    }
}
</script>

<style>

</style>
